import { observer } from 'mobx-react-lite'
import { type ClickToTextViewStore } from 'pages/clickToText/store'
import { ClickToTextViewContext } from 'pages/clickToText/pages/viewClickToText/context'
import { ClickToTextViewContent } from 'pages/clickToText/pages/createClickToText'

type IEditClickToTextViewProps = {
  store: ClickToTextViewStore
}

export const EditClickToTextView = observer(({ store }: IEditClickToTextViewProps) => {
  return (
    <ClickToTextViewContext.Provider value={store}>
      <ClickToTextViewContent />
    </ClickToTextViewContext.Provider>
  )
})
